
<app-page-scroll-content>
    <div>

        <app-encapsulate-view>

            @if (theForm != null) {
                <ng-template [cdkPortalOutlet]="theForm">
                </ng-template>
            }
            @else if (theFormView != null) {
                <ng-template *ngIf="theFormView != null" [cdkPortalOutlet]="theFormView">
                </ng-template>
                
                <!-- Flag for lambda print, don't remove, this will tell lambda print when start to print pdf -->
                @if(_secretLoaded) {
                    <div class="page-finished-fb"></div>
                }
            }
            @else if (_type == 3 && _pi != undefined && _pi.procedureFormId != undefined) {
                <app-form-preview (getReady)="isReady()" [procedureFormId]="_pi.procedureFormId">

                </app-form-preview>
            }

        </app-encapsulate-view>


    </div>
</app-page-scroll-content>